import { render, staticRenderFns } from "./BatchDetailsPage.vue?vue&type=template&id=3105cb4f&"
import script from "./BatchDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./BatchDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports